import {
  ArrowUpRight,
  Briefcase,
  Clapperboard,
  Fingerprint,
  GraduationCap,
  Handshake,
  Mic,
  Plane,
  Podcast,
  ShoppingBag,
  Users,
} from "lucide-react";
import { Eyebrow, Reveal, SectionShell } from "./Shared";

const ECOSYSTEM = [
  { icon: Users, label: "Athlete representation" },
  { icon: Handshake, label: "Sponsorship & endorsement development" },
  { icon: Fingerprint, label: "Personal-brand strategy" },
  { icon: Clapperboard, label: "Social-media & content development" },
  { icon: GraduationCap, label: "NIL opportunity development" },
  { icon: Mic, label: "Public appearances" },
  { icon: Plane, label: "Event & travel partnerships" },
  { icon: ShoppingBag, label: "Co-branded merchandise & product collaborations" },
  { icon: Podcast, label: "Media, podcast & broadcast opportunities" },
  { icon: Briefcase, label: "Post-career business development" },
];

export default function Ecosystem() {
  return (
    <SectionShell id="ecosystem">
      <Reveal>
        <Eyebrow className="mb-5">— 04 / The SMG Ecosystem</Eyebrow>
        <h2 className="max-w-3xl font-display text-4xl uppercase leading-[1.05] sm:text-5xl lg:text-6xl">
          One athlete. <span className="text-volt">An entire growth system.</span>
        </h2>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
          Every represented athlete gains access to SMG's brand, creative, media,
          AI, partnership and revenue-development capabilities.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-4 sm:grid-cols-2" data-testid="ecosystem-grid">
        {ECOSYSTEM.map((e, i) => (
          <Reveal key={e.label} delay={0.04 * i}>
            <div className="group flex h-full items-center gap-4 rounded-2xl border border-white/10 bg-surface px-5 py-5 transition-all duration-300 hover:border-volt/50 hover:bg-elev">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-volt/10 text-volt transition-colors group-hover:bg-volt group-hover:text-ink">
                <e.icon className="h-5 w-5" />
              </span>
              <p className="text-sm font-medium text-slate-200 sm:text-base">
                {e.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-12 flex justify-center">
          <a
            href="https://smgmediagroup.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="ecosystem-smg-media-link"
            className="group inline-flex items-center gap-3 rounded-full border border-volt/50 px-8 py-4 font-display text-base uppercase tracking-wider text-volt transition-all hover:bg-volt hover:text-ink"
          >
            See SMG Media Group
            <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </Reveal>
    </SectionShell>
  );
}
